import { Component } from '@angular/core';
import { ActiveCartFacade, Cart, OrderEntry } from '@spartacus/cart/base/root';
import { filter, Observable } from 'rxjs';
import { KnBrCommonService } from 'src/app/services/kn-br-common.service';
import { CwtSpinnerComponent } from '../../../../common/cwt-spinner/cwt-spinner.component';
import { CwtCartItemListComponent } from '../cwt-cart-item-list/cwt-cart-item-list.component';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'knbr-cwt-cart-products',
    templateUrl: './cwt-cart-products.component.html',
    styleUrls: ['./cwt-cart-products.component.scss'],
    imports: [CwtSpinnerComponent, CwtCartItemListComponent, AsyncPipe]
})
export class CwtCartProductsComponent {

  entries$: Observable<OrderEntry[]>;
  cart$: Observable<Cart>;

  constructor(protected activeCartService: ActiveCartFacade, protected commonService: KnBrCommonService) { }

  ngOnInit() {
    this.activeCartService.reloadActiveCart();
    this.entries$ = this.activeCartService
      .getEntries()
      .pipe(filter((entries) => {
        return entries.length >= 0
      })); 
  }
  


}
